import { render, staticRenderFns } from "./UpdateCourse.vue?vue&type=template&id=f47b145e&scoped=true&"
import script from "./UpdateCourse.vue?vue&type=script&lang=js&"
export * from "./UpdateCourse.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCourse.vue?vue&type=style&index=0&id=f47b145e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47b145e",
  null
  
)

export default component.exports